import { itemCount, CHANGE_EVENT, onStorageChange } from '@theme/quote-basket-store';

/**
 * <s-quote-count> — Shows the number of items in the quote basket.
 * Fills every [data-quote-count] descendant and hides [data-quote-badge] at zero.
 */
class SQuoteCount extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    document.addEventListener(CHANGE_EVENT, () => this.#render(), { signal });
    onStorageChange(() => this.#render(), signal);
    this.#render();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #render() {
    const count = itemCount();
    this.querySelectorAll('[data-quote-count]').forEach((node) => {
      node.textContent = String(count);
    });
    this.querySelectorAll('[data-quote-badge]').forEach((node) => {
      node.hidden = count === 0;
    });
    this.toggleAttribute('data-has-items', count > 0);
  }
}

if (!customElements.get('s-quote-count')) customElements.define('s-quote-count', SQuoteCount);
